(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sds-collection-feature-group"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sds-collection-feature-group')) {
    customElements.define('sds-collection-feature-group', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.carousel = this.querySelector('.sds-collection-feature-group__carousel');
        if (!this.carousel) return;
        this.carousel.addEventListener('carousel:change', (event) => {
          if (event.target === this.carousel) this.selectSlide(event.detail.index);
        }, options);
        this.carousel.addEventListener('keydown', (event) => {
          if (event.target !== this.carousel) return;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            if (document.dir === 'rtl') this.carousel.next?.();
            else this.carousel.previous?.();
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            if (document.dir === 'rtl') this.carousel.previous?.();
            else this.carousel.next?.();
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.sds-collection-feature-group__slide');
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.carousel.select?.(index, { instant: Boolean(event.detail?.load) });
        }, options);
        this.selectSlide(this.carousel.selectedIndex ?? 0);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.slides.forEach((slide) => this.stopSlide(slide));
      }

      get slides() {
        return this.carousel ? Array.from(this.carousel.children).filter((child) => child.classList.contains('sds-collection-feature-group__slide')) : [];
      }

      selectSlide(index) {
        const current = this.querySelector('[data-sds-feature-current]');
        if (current) current.textContent = String(index + 1);
        const dots = this.querySelector('.sds-collection-feature-group__dots');
        const dot = dots?.children[index];
        if (dots && dot) dots.scrollTo({ left: dot.offsetLeft - (dots.clientWidth - dot.clientWidth) / 2, behavior: 'auto' });
        this.slides.forEach((slide, slideIndex) => {
          const selected = slideIndex === index;
          if (!selected) {
            this.stopSlide(slide);
            if (slide.contains(document.activeElement)) this.carousel.focus({ preventScroll: true });
          }
          slide.inert = !selected;
          slide.classList.toggle('is-selected', selected);
        });
      }

      stopSlide(slide) {
        slide.querySelectorAll('video-media').forEach((media) => media.pause?.());
        slide.querySelectorAll('video').forEach((video) => video.pause());
        slide.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sds-collection-feature"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sds-collection-feature')) {
    customElements.define('sds-collection-feature', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('click', (event) => this.onClick(event), options);
        this.addEventListener('close', (event) => {
          if (event.target === this.dialog && this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, { ...options, capture: true });
      }

      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.opener = null;
      }

      get dialog() {
        return this.querySelector('.sds-collection-feature__dialog');
      }

      onClick(event) {
        const dialog = this.dialog;
        const close = event.target.closest('[data-sds-feature-close]');
        if (close && this.contains(close)) {
          dialog?.close();
          return;
        }
        if (dialog?.open && event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          return;
        }
        const hotspot = event.target.closest('[data-sds-shop-product][data-product-slot]');
        if (!hotspot || !this.contains(hotspot) || !dialog) return;
        const slot = hotspot.dataset.productSlot;
        if (!/^[1-6]$/.test(slot)) return;
        const template = this.querySelector(`template[data-sds-popup-slot="${slot}"]`);
        const body = dialog.querySelector('[data-sds-feature-dialog-body]');
        if (!template || !body) return;
        this.opener = hotspot;
        body.replaceChildren(template.content.cloneNode(true));
        if (!dialog.open) dialog.showModal();
        dialog.querySelector('[data-sds-feature-close]')?.focus({ preventScroll: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
